/**
 * Device-local preferences. Family ticks and acknowledgements never mutate the shared trip.
 * Inputs: checklist ids and revision numbers. Outputs: localStorage snapshots.
 */

const CHECKLIST_KEY = "tt-checklist-done";
const REVISION_KEY = "tt-ack-revision";

function readJson<T>(key: string, fallback: T): T {
  try {
    return JSON.parse(localStorage.getItem(key) ?? "null") as T ?? fallback;
  } catch {
    return fallback;
  }
}

export function readChecklistDone(): Record<string, boolean> {
  return readJson<Record<string, boolean>>(CHECKLIST_KEY, {});
}

export function toggleChecklistDone(id: string): Record<string, boolean> {
  const next = { ...readChecklistDone(), [id]: !readChecklistDone()[id] };
  if (!next[id]) delete next[id];
  localStorage.setItem(CHECKLIST_KEY, JSON.stringify(next));
  return next;
}

export function acknowledgedRevision(): number {
  return Number(localStorage.getItem(REVISION_KEY) ?? 0);
}

export function acknowledgeRevision(version: number) {
  localStorage.setItem(REVISION_KEY, String(version));
}
